import { render, staticRenderFns } from "./serbestfatura.vue?vue&type=template&id=20e74f6e"
import script from "./serbestfatura.vue?vue&type=script&lang=js"
export * from "./serbestfatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports